export default "__VITE_ASSET__GDiJRUXf__"